import React, { useState } from "react";
import useAuthEffect from "../../../hook/useAuthEffect";
import { fetchGlossaries } from "../../../redux/ducks/glossary";
import { useSelector, useDispatch } from "react-redux";

const GlossarySelect = (props) => {
  const dispatch = useDispatch();
  const glossaries = useSelector((state) => state.glossary.glossaries) || [];

  useAuthEffect(() => {
    dispatch(fetchGlossaries());
  }, []);

  return (
    <select
      name={props.name}
      className={"select select--primary " + props.className}
      onChange={props.onChange}
    >
      <option selected disabled></option>
      {Object.keys(glossaries).map((glossaryID) => {
        const glossary = glossaries[glossaryID];
        return <option value={glossaryID}>{glossary.name}</option>;
      })}
    </select>
  );
};

export default GlossarySelect;
